/**
 * @author pjh
 * @date 2025.07.31
 * @description 복비 입금 신청 모달
 */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import BokbiDepositContent from '../BokbiDepositContent';

interface IBokbiDepositModal {
    isOpen: boolean;
    onClose: () => void;
    onSubmit?: (data: any) => void;
}

const BokbiDepositModal: React.FC<IBokbiDepositModal> = ({ isOpen, onClose, onSubmit }) => {
    if (!isOpen) return null;

    const handleSubmit = (data: any) => {
        if (onSubmit) {
            onSubmit(data);
        }
        onClose();
    };

    return (
        <div className="saju_modal_overlay" onClick={onClose}>
            <div className="saju_modal_content" onClick={(e) => e.stopPropagation()}>
                <div className="saju_modal_header">
                    <h2>복비 입금 신청</h2>
                    <button className="saju_modal_close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                
                <BokbiDepositContent 
                    onSubmit={handleSubmit}
                />
            </div>
        </div>
    );
};

export default BokbiDepositModal;